import { useMemo } from "react";
import { useUIStore } from "../../../../store";
import { IconLightDark, IconSearch } from "../../../atoms";
import styles from "./Navbar.module.scss";

interface Props {
  restaurantName: string;
}

export const Navbar = ({ restaurantName }: Props) => {
  const isSticky = useUIStore((s) => s.isSticky);
  const config = useUIStore((s) => s.config);
  const imagesVersion = config.imagesVersion;
  const logo = config.logo;

  const headerImageUrl = (config as any).header_image_url as string | null | undefined;

  const headerBg = headerImageUrl?.trim()
    ? `${headerImageUrl.trim()}${headerImageUrl.includes("?") ? "&" : "?"}v=${imagesVersion || "1"}`
    : null;

  const logoSrc = useMemo(() => {
    if (!logo) return null;
    const sep = logo.includes("?") ? "&" : "?";
    return `${logo}${sep}v=${imagesVersion || "1"}`;
  }, [logo, imagesVersion]);

  return (
    <nav
      className={`${styles.containerNavbar} ${isSticky ? styles.navbarSticky : ""}`}
      style={
        !isSticky && headerBg
          ? {
              backgroundImage: `url(${headerBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : undefined
      }
    >
      {isSticky ? (
        <div className={styles.stickyBrand}>
          <p className={styles.title}>{restaurantName}</p>
        </div>
      ) : (
        logoSrc && (
          <div className={styles.brand}>
            <img src={logoSrc} className={styles.logo} alt={restaurantName} />
          </div>
        )
      )}

      <div className={styles.containerIconLightDarkSearch}>
        {!isSticky && <IconLightDark />}
        <IconSearch />
      </div>
    </nav>
  );
};
